import axios from "axios";
import protobuf from "protobufjs";
import React, { useState } from "react";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import Container from "../../hoc/Container/Container";
import Head from "../../layout/Head/Head";
import styles from "./index.module.scss";
import proto from "./opt.proto";

const OPTOUT_COOKIE_KEY = "cnx_optout";

const OptOutPage = (props) => {
  const [isChecked, setIsChecked] = useState(
    getCookieValue(OPTOUT_COOKIE_KEY) !== "True",
  );

  const checkHandler = () => {
    const newValue = !isChecked;
    setIsChecked(newValue);
    saveSettings(newValue);
  };

  const getProtoEncodedData = async (isPersonalizationAllowed) => {
    try {
      const root = await protobuf.load(proto);
      const Request = root.lookupType("contracts.core.opt.v1.OptRequest");
      const data = { optOut: !isPersonalizationAllowed };
      const errMsg = Request.verify(data);
      if (errMsg) {
        throw Error(errMsg);
      }

      const serialized = Request.encode(data).finish();
      const decoder = new TextDecoder();
      return decoder.decode(serialized);
    } catch (error) {
      console.log("Get Protobuf: error:: ", error);
    }
  };

  const saveSettings = async (isPersonalizationAllowed) => {
    // fetch protobuf request
    axios
      .post(
        `${process.env.REACT_APP_OPTOUT_URL}`,
        await getProtoEncodedData(isPersonalizationAllowed),
        {
          withCredentials: true,
          headers: {
            "Content-Type": "multipart/form-data",
          },
          responseType: "arraybuffer",
        },
      )
      .then(() => {});
  };

  function getCookieValue(key) {
    const cookieValue = document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${key}=`));
    if (cookieValue) {
      return cookieValue.split("=")[1];
    }
    return "";
  }

  return (
    <div>
      <Head title="Connatix - Do Not Sell or Share My Personal Information" />
      <Container>
        <Breadcrumbs
          {...props}
          currentPositionText="Do Not Sell or Share My Personal Information"
        />
        <div className={styles["optout-wrapper"]}>
          <h1>
            Opt-Out of Targeted Advertising and Selling/Sharing of My Personal
            Information
          </h1>
          <p>
            Connatix operates a video advertising solution (the "Solution")
            which is used on various websites, apps, and other online media
            ("Online Properties") owned and operated by others. When you access
            an Online Property that uses the Solution, Connatix collects and
            processes limited, pseudonymous personal information to improve the
            personalization and relevancy of ads you may see, as explained in
            more detail in our{" "}
            <a
              href="https://jwx.com/legal/privacy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Video Platform Privacy Notice
            </a>
            . We then share your personal information for online behaviorally
            targeted ads. However, you have a right to opt-out of that sharing,
            which means that you have a right to direct us to stop sharing your
            personal information for targeted ads.
          </p>
          <p>
            Connatix honors your right to opt-out of the use, sharing, or sale
            of your personal information when you indicate your preference below
            on each device/browser you use. After opting-out, a non-personalized
            opt-out cookie will be placed in your browser to retain your opt-out
            status. After opting out, you may still see ads facilitated by
            Connatix, but they will no longer involve using, sharing, or selling
            your personal information. Please note that if you delete the
            opt-out cookie or it expires based on your browser’s settings, you
            will need to opt-out again on this page to re-establish your opt-out
            status. If we are unable to write the opt-out cookie due to an ad
            blocker or browser restriction, we will not be able to maintain the
            opt-out state in your browser, however, the blocker may effectively
            prevent use of your personal information.
            <br />
            If you would like to opt-out in other browsers you use, you must
            visit this page from each device/browser to enable the opt-out
            cookie to be written. To opt-out on other device types, the NAI
            provides helpful guides; learn more about opting out on{" "}
            <a
              href="https://thenai.org/how-to-opt-out/advertising-privacy-settings-on-mobile-devices/"
              target="_blank"
              rel="noopener noreferrer"
            >
              mobile devices
            </a>{" "}
            and{" "}
            <a
              href="https://thenai.org/how-to-opt-out/advertising-privacy-settings-on-tvs-streaming-devices/"
              target="_blank"
              rel="noopener noreferrer"
            >
              connected TVs and video devices
            </a>
            .
          </p>

          <div className={styles["optout-wrapper__preference-section"]}>
            <p className={styles["preference-section__title"]}>
              Allow Ad Personalization
            </p>
            <div className={styles["switch--primary"]}>
              <div className={styles["switch--primary__input"]}>
                <input
                  type="checkbox"
                  className={styles["switch--primary__checkbox"]}
                  checked={isChecked}
                  onChange={checkHandler}
                />
                <div className={styles["switch--primary__knobs"]}></div>
                <div className={styles["switch--primary__layer"]}></div>
              </div>
              <div className={styles["switch--primary__label"]}>
                {isChecked ? "Yes" : "No"}
              </div>
            </div>
          </div>

          <div className={styles["optout-wrapper__divider"]}></div>
        </div>
      </Container>
    </div>
  );
};

export default OptOutPage;
